import { Tab, useTheme } from '@mui/material'
import TabIcon from './TabIcon'
import { TabLabel } from './TabLabel'

const GoogleDocTab = ({ handoffDocId }: { handoffDocId: string }) => {
  const theme = useTheme()
  const title = 'Kickoff Call Doc'
  return (
    <Tab
      className="tab-routing-custom"
      icon={<TabIcon title={title} />}
      label={<TabLabel label={title} />}
      disableRipple
      sx={{
        '& .MuiTab-iconWrapper': { m: 0 }, // center icon perfectly
        '--tab-routing-icon-color': theme.palette.text.highlight,
      }}
      onClick={() =>
        window.open(`https://docs.google.com/document/d/${handoffDocId}/edit`, '_blank', 'noopener,noreferrer')
      }
    />
  )
}

export default GoogleDocTab
